var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZedintroIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29 19.1496V32.117C29 32.4838 28.8539 32.8356 28.594 33.0949C28.334 33.3543 27.9815 33.5 27.6138 33.5H17.5972V19.1496C17.5988 18.1157 17.3093 17.1022 16.7617 16.2245C16.2141 15.3467 15.4305 14.64 14.5 14.1849C15.259 13.8087 16.0943 13.6108 16.9418 13.6062H23.461C24.1899 13.6062 24.9115 13.7497 25.5847 14.0285C26.2579 14.3073 26.8692 14.7159 27.3838 15.2309C27.8984 15.7459 28.306 16.3571 28.5834 17.0296C28.8607 17.702 29.0023 18.4225 29 19.1496V19.1496Z",
    fill: "#01CBBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5972 19.1496V33.5H11.4028V19.1496C11.4026 18.116 11.6927 17.1031 12.2401 16.2256C12.7875 15.3481 13.5704 14.6411 14.5 14.1849C15.4305 14.64 16.2141 15.3467 16.7617 16.2245C17.3093 17.1022 17.5988 18.1157 17.5972 19.1496V19.1496Z",
    fill: "#1896B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.5 14.1849C13.5704 14.6411 12.7875 15.3481 12.2401 16.2256C11.6927 17.1031 11.4026 18.116 11.4028 19.1496V33.5H1.38621C1.01856 33.5 0.665969 33.3543 0.406007 33.0949C0.146044 32.8356 0 32.4838 0 32.117V19.1496C0 17.684 0.5836 16.2785 1.62236 15.2421C2.66113 14.2058 4.06999 13.6236 5.53902 13.6236H12.0582C12.9045 13.622 13.7398 13.814 14.5 14.1849V14.1849Z",
    fill: "#5E00C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.2645 11.853C11.4069 11.853 13.9543 9.31153 13.9543 6.17649C13.9543 3.04145 11.4069 0.5 8.2645 0.5C5.12211 0.5 2.57471 3.04145 2.57471 6.17649C2.57471 9.31153 5.12211 11.853 8.2645 11.853Z",
    fill: "#5E00C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.7987 11.853C23.9411 11.853 26.4885 9.31153 26.4885 6.17649C26.4885 3.04145 23.9411 0.5 20.7987 0.5C17.6563 0.5 15.1089 3.04145 15.1089 6.17649C15.1089 9.31153 17.6563 11.853 20.7987 11.853Z",
    fill: "#01CBBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZedintroIcon);
export default __webpack_public_path__ + "static/media/Zedintro-icon.629b0de0e579f31e59de962a449e839c.svg";
export { ForwardRef as ReactComponent };